// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"304":"254f20bd","360":"b966037b"}[chunkId] + ".chunk.css";
};